import React, { useEffect } from "react";
import { Hero } from "@/components/home/Hero";
import { VerticalStrip } from "@/components/home/VerticalStrip";
import { RegionMap } from "@/components/home/RegionMap";
import { StatsBar, Marquee } from "@/components/home/StatsBar";
import { DrillDemo } from "@/components/home/DrillDemo";
import { Manifesto } from "@/components/home/Manifesto";
import { Pillars, PulseNetwork } from "@/components/home/Pillars";
import { SymbolOfTheDay } from "@/components/home/SymbolOfTheDay";
import { useTTS } from "@/context/TTSContext";
import { Seo } from "@/components/site/Seo";
import { orgAndWebsiteJsonLd } from "@/lib/seo";

export default function Home() {
  const tts = useTTS();
  useEffect(() => {
    tts?.setContent([
      "Welcome to USAPulse. Explore the pulse of America.",
      "Discover the rich history, diverse culture, people, places and opportunities across the United States, organized from the nation down to your neighborhood.",
      "USAPulse is a living digital knowledge network for the United States, built with geography as its spine.",
    ]);
  }, [tts]);

  return (
    <>
      <Seo
        title="USAPulse.net — Explore the Pulse of America"
        titleFull
        path="/"
        description="USAPulse is a living digital knowledge network for the United States. Explore every state, county, city and town — their people, history, culture, economy, government and daily local pulse."
        jsonLd={orgAndWebsiteJsonLd()}
      />
      <Hero />
      <VerticalStrip />
      <RegionMap />
      <SymbolOfTheDay />
      <StatsBar />
      <Marquee />
      <DrillDemo />
      <Manifesto />
      <Pillars />
      <PulseNetwork />
    </>
  );
}
